import { Link } from "react-router-dom";

const stats = [
  { value: "24", label: "收录作品", hint: "演示数据" },
  { value: "6", label: "内容分类" },
  { value: "2009 - 2023", label: "时间跨度" },
];

export default function IntroSection() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-compass-3-line" aria-hidden="true" />
            关于本站
          </span>
          <h2 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">
            专注韩国 R 级影视作品的资料整理
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            韩国三级电影以专业资料的形态，整理韩国 R 级与成人向文艺作品的基本信息与剧情介绍。我们按类型、年份与评分进行系统分类，帮助影迷在浏览与查找之间快速定位感兴趣的作品。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            站内所有内容均为资料展示，不提供在线播放、下载或任何第三方接口对接；收藏与分享仅为前端演示功能。
          </p>
          <Link
            to="/about"
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-line text-base" aria-hidden="true" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 md:grid-cols-1">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-100 px-4 py-4"
            >
              <span className="text-lg font-black text-primary-600 md:text-xl">{stat.value}</span>
              <span className="mt-1 text-sm font-medium text-foreground-800">{stat.label}</span>
              {stat.hint ? <span className="mt-0.5 text-xs text-foreground-400">{stat.hint}</span> : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}